import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
    RiskRegisterCardSlotOption,
    RiskRegisterCardSlotOptionLabels,
} from "src/app/enums/riskRegisterCardSlot.enum";
import { TableExtendedRiskRegister } from "src/app/models/risk-assessment.model";
import {
    RiskRegisterCardSlotKey,
    RiskRegisterCardSlotPickerData,
    RiskRegisterCardSlotPickerResult,
    RiskRegisterCardSlotPickerRow,
    RiskRegisterCardSlots,
} from "src/app/models/risk-register-card.model";
import { RISK_REGISTER_CARD_SLOT_LABELS } from "src/app/shared/constants/riskRegisterCardSlot.constants";
import { CARD_SLOT_OPTIONS } from "src/app/components/risk-register/risk-register-card-slots.util";

@Component({
    standalone: false,
    selector: "app-risk-register-card-slot-picker",
    templateUrl: "./risk-register-card-slot-picker.component.html",
    styleUrl: "./risk-register-card-slot-picker.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskRegisterCardSlotPickerComponent {
    draft: RiskRegisterCardSlots;
    activeSlot: RiskRegisterCardSlotKey;
    hoverSlot: RiskRegisterCardSlotKey | null = null;
    rows: RiskRegisterCardSlotPickerRow[] = [];
    previewRegister: TableExtendedRiskRegister | null = null;
    readonly slotLabels = RISK_REGISTER_CARD_SLOT_LABELS;
    readonly optionsTitleKey = "Show in {{slot}}";
    readonly options = CARD_SLOT_OPTIONS.map((value) => ({
        value,
        label: RiskRegisterCardSlotOptionLabels[value],
    }));
    constructor(
        @Inject(MAT_DIALOG_DATA) readonly data: RiskRegisterCardSlotPickerData,
        private readonly dialogRef: MatDialogRef<RiskRegisterCardSlotPickerComponent, RiskRegisterCardSlotPickerResult>,
    ) {
        this.activeSlot = data.editableSlots[0];
        this.draft = { ...data.slots };
        this.refresh();
    }

    selectSlot(key: RiskRegisterCardSlotKey): void {
        if (this.data.editableSlots.includes(key)) {
            this.activeSlot = key;
        }
    }

    hover(key: RiskRegisterCardSlotKey | null): void {
        this.hoverSlot = key;
    }

    previewOption(option: RiskRegisterCardSlotOption | null): void {
        const slots = option === null ? this.draft : { ...this.draft, [this.activeSlot]: option };
        this.previewRegister = this.data.preview(slots);
    }

    select(option: RiskRegisterCardSlotOption): void {
        if (this.draft[this.activeSlot] !== option) {
            this.draft = { ...this.draft, [this.activeSlot]: option };
            this.refresh();
        }
    }

    reset(): void {
        this.draft = { ...this.data.defaults };
        this.refresh();
    }

    apply(saveAsView = false): void {
        this.dialogRef.close({ slots: this.draft, saveAsView });
    }

    private refresh(): void {
        this.rows = this.data.editableSlots.map((key) => ({
            key,
            label: RISK_REGISTER_CARD_SLOT_LABELS[key],
            optionLabel: RiskRegisterCardSlotOptionLabels[this.draft[key]],
        }));
        this.previewRegister = this.data.preview(this.draft);
    }
}
